import axios from "axios";
import { constant } from "common/constant";

export const postApi = async (path, data, login) => {
  try {
    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token");

    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    let result = await axios.post(constant.baseUrl + path, data, { headers });

    if (result.data?.token && result.data?.token !== null) {
      if (login) {
        localStorage.setItem("token", result.data?.token);
      } else {
        sessionStorage.setItem("token", result.data?.token);
      }
      localStorage.setItem("user", JSON.stringify(result.data?.user));
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const putApi = async (path, data, id) => {
  try {
    let result = await axios.put(constant.baseUrl + path, data, {
      headers: {
        Authorization: `Bearer ${
          localStorage.getItem("token") || sessionStorage.getItem("token")
          }`,
      },
    });
    return result;
  } catch (e) {
    console.error(e);
    return e;
  }
};

export const deleteApi = async (path, param) => {
  try {
    let result = await axios.delete(constant.baseUrl + path + param, {
      headers: {
        Authorization: `Bearer ${
          localStorage.getItem("token") || sessionStorage.getItem("token")
          }`,
      },
    });
    if (result.data?.token && result.data?.token !== null) {
      localStorage.setItem("token", result.data?.token);
    }
    return result;
  } catch (e) {
    console.error(e);
    return e;
  }
};

export const deleteManyApi = async (path, data) => {
  try {
    let result = await axios.post(constant.baseUrl + path, data, {
      headers: {
        Authorization: `Bearer ${
          localStorage.getItem("token") || sessionStorage.getItem("token")
          }`,
      },
    });
    if (result.data?.token && result.data?.token !== null) {
      localStorage.setItem("token", result.data?.token);
    }
    return result;
  } catch (e) {
    console.error(e);
    return e;
  }
};

export const getApi = async (path, id) => {
  try {
    if (id) {
      let result = await axios.get(constant.baseUrl + path + id, {
        headers: {
          Authorization: `Bearer ${
            localStorage.getItem("token") || sessionStorage.getItem("token")
            }`,
        },
      });
      return result;
    } else {
      let result = await axios.get(constant.baseUrl + path, {
        headers: {
          Authorization: `Bearer ${
            localStorage.getItem("token") || sessionStorage.getItem("token")
            }`,
        },
      });
      return result;
    }
  } catch (e) {
    console.error(e);
    return e;
  }
};

export const postApiMultipart = async (path, formData) => {
  try {
    let result = await axios.post(constant.baseUrl + path, formData, {
      headers: {
        Authorization: `Bearer ${
          localStorage.getItem("token") || sessionStorage.getItem("token")
          }`,
        "Content-Type": "multipart/form-data",
      },
    });
    return result;
  } catch (e) {
    console.error(e);
    return e;
  }
};

export const patchApi = async (path, data) => {
  try {
    let result = await axios.patch(constant.baseUrl + path, data, {
      headers: {
        Authorization: `Bearer ${
          localStorage.getItem("token") || sessionStorage.getItem("token")
          }`,
      },
    });
    return result;
  } catch (e) {
    console.error(e);
    return e;
  }
};
